import * as React from 'react'
import { useFormikContext } from 'formik'
import Button from '@mui/material/Button'

import { CancelButton } from '../CancelButton'
import DialogActions from '@mui/material/DialogActions'

export function Footer() {
  const { submitForm } = useFormikContext()

  return (
    <DialogActions
      sx={{
        px: 2.4,
        pb: 2.4,
      }}
    >
      <CancelButton />
      <Button
        variant="contained"
        onClick={submitForm}
        data-test-id="locAndSvcs-submitBtn"
      >
        Continue
      </Button>
    </DialogActions>
  )
}
